// Этот файл содержит логику регистрации и управления Service Worker для PWA

// Функция проверки, находимся ли мы в производственной среде
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// Функция регистрации Service Worker
export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // URL-адрес, на котором размещается наше приложение (используется для доступа к service worker)
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    
    if (publicUrl.origin !== window.location.origin) {
      // Наш service worker не будет работать, если PUBLIC_URL находится на другом домене
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // Запуск на localhost: проверка доступности service worker
        checkValidServiceWorker(swUrl, config);

        // Добавляем логирование для разработки
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'Это веб-приложение обслуживается кэшем первым через service worker. ' +
              'Подробнее об этом здесь: https://cra.link/PWA'
          );
        });
      } else {
        // Не localhost: просто регистрируем service worker
        registerValidSW(swUrl, config);
      }
    });
  } else {
    console.log('Service Worker не поддерживается в этой среде или браузере');
  }
}

// Функция для регистрации действительного Service Worker
function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Проверка обновлений service worker при обнаружении новой версии
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Доступно обновление
              console.log('Доступно новое содержимое, обновляем кэш...');

              // Выполняем колбэк onUpdate, если он был предоставлен
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Всё кэшировано для использования в автономном режиме
              console.log('Контент кэширован для использования в автономном режиме.');

              // Выполняем колбэк onSuccess, если он был предоставлен
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Ошибка при регистрации service worker:', error);
    });
}

// Функция проверки валидности Service Worker
function checkValidServiceWorker(swUrl, config) {
  // Проверяем, можем ли мы найти service worker
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Убеждаемся, что service worker существует и что мы действительно получаем JS-файл
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Не найден service worker: возможно, работает другое приложение
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker найден, продолжаем как обычно
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('Нет подключения к интернету. Приложение работает в автономном режиме.');
    });
}

// Функция для отмены регистрации Service Worker
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
